import { PARTNERS_TABS } from "@/Routes/partnerSidebar.utility";
import { apiRequest } from "@repo/api-services/Axios";

import URLS from "@repo/api-services/URLS";
import { stringUtility } from "@repo/utilities/string.utility.ts";

export const getRedirectPathFromAuth = async () => {
  const authUserResponse = await apiRequest.get(URLS.AUTH_USER);
  const permissionsMap = authUserResponse?.data?.permissions ?? {};

  const accessibleTabCodes = new Set<string>(
    Object.keys(permissionsMap).map((permissionKey) =>
      stringUtility.replaceCharAll(permissionKey, "_", "-")
    )
  );

  const firstAccessibleTab = PARTNERS_TABS.flatMap(
    (tab) => tab.subTabs ?? [tab]
  ).find((tab) => accessibleTabCodes.has(tab.code));

  return firstAccessibleTab?.path ?? "/login";
};
